import "./style.css";
import "animate.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import Contact from "../Contact/Contact";
import Carousel from "./Carousel";
import Posters from "./Posters";
import Press from "./Press";
import ChromeTitle from "./ChromeTitle";

// One background for the whole page: near-black with a fine grain and soft
// color glows spread down its length. The dark sections are transparent, so
// the color flows through them with no edges between sections.
const PAGE_BACKGROUND = [
  `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.06'/%3E%3C/svg%3E")`,
  "radial-gradient(900px 650px at 82% 21%, rgba(60, 50, 120, 0.4) 0%, transparent 70%)",
  "radial-gradient(900px 700px at 12% 33%, rgba(60, 50, 120, 0.45) 0%, transparent 70%)",
  "radial-gradient(800px 650px at 88% 41%, rgba(50, 165, 219, 0.12) 0%, transparent 70%)",
  "radial-gradient(900px 700px at 82% 52%, rgba(50, 40, 100, 0.45) 0%, transparent 70%)",
  "radial-gradient(1000px 750px at 15% 62%, rgba(60, 50, 120, 0.5) 0%, transparent 70%)",
  "radial-gradient(700px 600px at 60% 71%, rgba(80, 60, 140, 0.25) 0%, transparent 70%)",
  "radial-gradient(900px 700px at 85% 81%, rgba(45, 35, 90, 0.45) 0%, transparent 70%)",
  "radial-gradient(1000px 750px at 20% 93%, rgba(60, 50, 120, 0.4) 0%, transparent 70%)",
].join(", ");

const Home = () => {
  const [modalOpen, setModal] = useState(false);
  const [top, setTop] = useState(true);
  const [mobile, setMobile] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const [isHeaderLogo, setHeaderLogo] = useState(false);
  useEffect(() => {
    AOS.init();
  });
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  useEffect(() => {
    handleResize();
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 400) {
      setHeaderLogo(true);
    } else {
      setHeaderLogo(false);
    }
    if (window.scrollY > 0) {
      setTop(false);
    } else {
      setTop(true);
    }
  };

  const handleResize = () => {
    if (window.innerWidth < 768) {
      setMobile(true);
    } else {
      setMobile(false);
      setSidebar(false);
    }
  };

  const handleGoLinkedin = () => {
    window.open(
      "https://www.linkedin.com/company/paperairplane-media/",
      "_blank",
    );
  };

  const handleScrollToSection = (section) => {
    setSidebar(false);
    const element = document.getElementById(section);
    //you can do it by jquery. no matter
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  const handleSidebar = () => {
    setSidebar(!sidebar);
  };

  const MenuItems = () => {
    const NavTag = sidebar ? "h2" : "h3";
    return (
      <div
        style={{
          display: "flex",
          flexDirection: sidebar ? "column" : "row",
          justifyContent: "center",
          alignItems: "center",
          marginTop: sidebar ? "-100px" : "",
        }}
      >
        <div
          style={{
            marginRight: !sidebar ? "20px" : "",
            marginBottom: sidebar ? "20px" : "",
          }}
        >
          <NavTag
            className="heading heading--inverted grow"
            onClick={() => handleScrollToSection("products")}
          >
            Innovations
          </NavTag>
        </div>
        {/* <div
          style={{
            marginRight: !sidebar ? "20px" : "",
            marginBottom: sidebar ? "20px" : "",
          }}
        >
          <Header
            as={sidebar ? "h2" : "h3"}
            className="grow"
            inverted
            content="About Us"
            onClick={() => handleScrollToSection("about")}
          />
        </div> */}
        <div
          style={{
            marginRight: !sidebar ? "20px" : "",
            marginBottom: sidebar ? "20px" : "",
          }}
        >
          <NavTag
            className="heading heading--inverted grow"
            onClick={() => handleScrollToSection("press")}
          >
            In The Press
          </NavTag>
        </div>
        <div
          style={{
            marginRight: !sidebar ? "20px" : "",
            marginBottom: sidebar ? "20px" : "",
          }}
        >
          <NavTag
            className="heading heading--inverted grow"
            onClick={() => handleScrollToSection("team")}
          >
            Our Team
          </NavTag>
        </div>

        <div
          style={{
            marginRight: !sidebar ? "20px" : "",
            marginBottom: sidebar ? "20px" : "",
          }}
        >
          <NavTag
            className={`heading heading--inverted grow${sidebar ? "" : " nav-cta"}`}
            onClick={() => setModal(true)}
          >
            Contact
          </NavTag>
        </div>
      </div>
    );
  };

  return (
    <div
      id="home-container"
      // Also covers the seams: sections have fractional heights, which would
      // otherwise show the page background as thin lines between them.
      style={{ backgroundColor: "#0d0d14", backgroundImage: PAGE_BACKGROUND }}
    >
      <div
        style={{
          width: "100%",
          // Fills the window above the logo strip, but grows to fit its content
          // on short windows (the padding clears the fixed menu bar).
          minHeight: "calc(100vh - 200px)",
          padding: "100px 0 40px",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          alignItems: "center",
          backgroundImage: "url(./images/home-hero-1.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="wrap-section"
      >
        <div
          id="header"
          style={{
            width: "100%",
            height: "100px",
            position: "fixed",
            top: "0px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: top ? "rgba(0,0,0,0.0)" : "rgba(15,15,25,0.85)",
            backdropFilter: top ? "none" : "blur(20px)",
            WebkitBackdropFilter: top ? "none" : "blur(20px)",
            boxShadow: top ? "" : "0px 4px 30px rgba(0,0,0,0.5)",
            borderBottom: top ? "none" : "1px solid rgba(255,255,255,0.05)",
            transition: "all 0.3s ease",
            zIndex: 4,
          }}
        >
          <div
            style={{
              padding: "10px",
              opacity: isHeaderLogo ? 1 : 0,
              transition: "opacity ease-in-out 0.5s",
            }}
          >
            <a href="/">
              <img src="./images/logo.png" width="150x" />
            </a>
          </div>
          {!mobile && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <MenuItems />
              <div style={{ marginRight: "20px" }}>
                <button
                  type="button"
                  className="icon-button"
                  aria-label="PaperAirplane on LinkedIn"
                  onClick={handleGoLinkedin}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      fill="currentColor"
                      d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )}
          {mobile && (
            <div style={{ marginRight: "20px" }}>
              <button
                type="button"
                className="icon-button"
                aria-label={sidebar ? "Close menu" : "Open menu"}
                onClick={handleSidebar}
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    d={sidebar ? "M5 5l14 14M19 5L5 19" : "M2 5h20M2 12h20M2 19h20"}
                    stroke="currentColor"
                    strokeWidth="3.4"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>
          )}
          {mobile && (
            <div
              style={{
                opacity: sidebar ? 1 : 0,
                zIndex: 3,
                backgroundColor: "rgba(15,15,25,0.95)",
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
                position: "fixed",
                top: "100px",
                width: "100%",
                height: sidebar ? "100vh" : "0px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                transition: "height ease-in-out 0.2s",
              }}
            >
              <MenuItems />
            </div>
          )}
        </div>

        <div style={{ width: "100%" }}>
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              padding: "10px",
            }}
            className="flex-section"
          >
            {/* <div
              style={{
                maxWidth: "800px",
                minWidth: "365px",
                // marginLeft: "100px",
                flex: 1,
              }}
              className="mobile-margin"
            >
              <Header
                as="h1"
                inverted
                style={{
                  fontSize: "3.2em",
                  textAlign: "center",
                  // textShadow: "1px 1px 10px #000000",
                }}
              >
                PaperAirplane
                <Header.Subheader style={{ fontSize: ".6em" }}>
                  <p>
                    A First-of-its-Kind Cinema Marketing Agency serving Studios,
                    Content Providers, Exhibitors and Marketplace Partners.
                  </p>
                  <p>Where Innovation Takes Flight.</p>
                </Header.Subheader>
              </Header>
            </div> */}
            <div
              style={{
                maxWidth: "800px",
                minWidth: "365px",
                // marginLeft: "100px",
                textAlign: "center",
                flex: 1,
                animationDuration: "0.6s",
              }}
              className="mobile-margin animate__animated animate__fadeIn"
            >
              <img
                src="./images/logo.png"
                width={mobile ? "200px" : "300px"}
                alt="PaperAirplane"
              />
              <h1
                className="heading heading--inverted"
                style={{
                  fontSize: mobile ? "2.3em" : "3.4em",
                  textAlign: "center",
                  margin: "24px 0 12px",
                }}
              >
                Where Innovation Takes Flight
              </h1>
              <p className="hero-sub">
                A First-of-its-Kind Cinema Marketing Agency serving Studios,
                Content Providers, Exhibitors and Marketplace Partners.
              </p>
              <div className="hero-ctas">
                <button
                  type="button"
                  className="hero-cta hero-cta--primary"
                  onClick={() => setModal(true)}
                >
                  Work with us
                </button>
                <button
                  type="button"
                  className="hero-cta hero-cta--secondary"
                  onClick={() => handleScrollToSection("products")}
                >
                  Learn More
                </button>
              </div>
              <div className="hero-stats">
                <div>
                  <div className="hero-stat-number">40+</div>
                  <div className="hero-stat-label">Studio & cinema clients</div>
                </div>
                <div>
                  <div className="hero-stat-number">98%</div>
                  <div className="hero-stat-label">Of domestic exhibitors</div>
                </div>
                <div>
                  <div className="hero-stat-number">2M+</div>
                  <div className="hero-stat-label">Hangar downloads</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          height: "200px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // Light, with soft brand-colored glows. The logos' white backgrounds
          // blend into it (see carousel.css).
          background:
            "radial-gradient(ellipse at 15% 50%, rgba(50, 165, 219, 0.16) 0%, transparent 60%), radial-gradient(ellipse at 85% 50%, rgba(110, 90, 190, 0.14) 0%, transparent 60%), #f3f5fa",
          boxShadow:
            "inset 0 14px 22px -14px rgba(0, 0, 0, 0.45), inset 0 -14px 22px -14px rgba(0, 0, 0, 0.45)",
          flexDirection: "column",
        }}
      >
        {/* <Header as="h1" style={{ fontSize: "2.2em" }}>
          Friends and Partners
        </Header> */}
        <Carousel />
      </div>
      <div
        style={{
          width: "100%",
          padding: mobile ? "70px 0" : "120px 0",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <div
          data-aos="fade-up"
          className="wrap-section"
          style={{ width: "100%", maxWidth: "1600px", display: "flex" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flex: 1,
            }}
            className="flex-section"
          >
            <div
              style={{ width: "555px", margin: "50px" }}
              className="mobile-margin"
            >
              <h2
                data-aos="fade-up"
                className="heading"
                style={{
                  fontSize: mobile ? "1.9em" : "2.6em",
                  color: "#F1F1F1",
                }}
              >
                PaperAirplane is the industry’s trusted partner, with over 40
                studio and cinema clients, working daily with more than 98% of
                domestic exhibitors.
              </h2>
            </div>
          </div>
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="flex-section"
          >
            <div
              style={{ width: "555px", margin: "50px" }}
              className="mobile-margin"
            >
              <ul
                data-aos="fade-up"
                className="bullet-list"
                style={{
                  fontSize: mobile ? "1.45em" : "2em",
                  color: "#F1F1F1",
                  // textAlign: "center",
                }}
              >
                <li>Asset Management</li>
                <li>Asset Creation</li>
                <li>Campaign Management</li>
                <li>Media Buying Across Exhibitor Platforms</li>
                <li>Group Sales Program Management</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          padding: "90px 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
        data-aos="fade-up"
      >
        <h2
          className="heading heading--inverted"
          style={{ fontSize: "3.2em", margin: "0 0 36px" }}
        >
          <ChromeTitle text="Projects" />
        </h2>
        <Posters />
      </div>
      <div
        id="products"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: "90px 30px",
          scrollMarginTop: "100px",
        }}
      >
        <div data-aos="fade-up">
          <div
            className="heading heading--inverted"
            style={{ fontSize: "3.2em" }}
          >
            <ChromeTitle text="Innovations" />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
          }}
          className="wrap-section"
          data-aos="fade-up"
        >
          <div className="flex-section" style={{ flex: 1 }}>
            <div
              style={{
                maxWidth: "500px",
                margin: "50px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              className="mobile-margin"
            >
              <img
                data-aos="fade-up"
                src="./images/the-hangar-logo.png"
                width="200px"
                height="105px"
              />
              <div
                className="heading heading--inverted"
                style={{ fontSize: "1.6em" }}
                data-aos="fade-up"
              >
                A revolutionary and proprietary Digital Asset Manager designed
                to efficiently deliver digital marketing assets of all types to
                Exhibitors worldwide, empowering clients with seamless asset
                distribution and tracking capabilities.
                <div className="heading__sub">
                  <hr className="rule rule--inverted" />
                  <ul
                    data-aos="fade-up"
                    className="bullet-list"
                    style={{ fontSize: "1.4em", textAlign: "left" }}
                  >
                    <li>Over 2,000 Titles Hosted to Date</li>
                    <li>Over 175,000 Assets Hosted to Date</li>
                    <li>Over 2 Million Downloads to Date</li>
                    <li>Over 4,000 Users and Growing!</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* spacing between the two products when they stack */}
          <div style={{ margin: "2rem 0" }} />
          <div className="flex-section" style={{ flex: 1 }}>
            <div
              style={{
                maxWidth: "500px",
                margin: "50px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              className="mobile-margin"
            >
              <img
                data-aos="fade-up"
                src="./images/the-tower-logo.png"
                width="200px"
                height="105px"
              />
              <div
                className="heading heading--inverted"
                style={{ fontSize: "1.6em" }}
                data-aos="fade-up"
              >
                A powerful and groundbreaking Group Sales management tool that
                simplifies the group sales process, seamlessly connecting
                Exhibitors and Studios, allowing for increased visibility and
                for more sales to be closed.
                <div className="heading__sub">
                  <hr className="rule rule--inverted" />
                  <ul
                    data-aos="fade-up"
                    className="bullet-list"
                    style={{ fontSize: "1.4em", textAlign: "left" }}
                  >
                    <li>Manages Group Sales Leads</li>
                    <li>Tracks Box Office</li>
                    <li>
                      High-Quality Customizable Forms and Integrations
                    </li>
                    <li>
                      Collects Data for Outreach and Retargeting
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div
        id="about"
        style={{
          width: "100%",
          height: "calc(100vh - 50px)",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          alignItems: "center",
          backgroundColor: "#F1F1F1",
          backgroundImage: "url(./images/home-hero-5.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          scrollMarginTop: "100px",
        }}
      >
        <div
          data-aos="fade-up"
          className="wrap-section"
          style={{ width: "100%", display: "flex" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flex: 1,
            }}
            className="flex-section"
          >
            <div
              style={{ width: "555px", margin: "50px" }}
              className="mobile-margin"
            >
              <Header
                inverted
                as="h1"
                data-aos="fade-up"
                style={{
                  fontSize: "3.2em",
                  textAlign: "center",
                }}
              >
                About Us
                <Header.Subheader
                  style={{ textAlign: "center", fontSize: "1.2rem" }}
                >
                  <p data-aos="fade-up">
                    Co-founders Mike Polydoros and Will Preuss possess extensive
                    experience in cinema marketing, having spearheaded
                    in-theatre campaigns for iconic franchises like THE HUNGER
                    GAMES, THE EXPENDABLES, SAW, TYLER PERRY and JOHN WICK, as
                    well as acclaimed box office hits such as WONDER, LA LA LAND
                    and KNIVES OUT. PaperAirplane builds upon this success,
                    developing tools and strategies that reach moviegoers and
                    drive box office success. Since launching in 2020,
                    PaperAirplane has created and implemented in-theatre
                    campaigns for numerous films, including FREELANCE, RADICAL,
                    THE LONG GAME, HYPNOTIC and the Academy Award winning
                    GODZILLA MINUS ONE. Key members of the PaperAirplane flight
                    crew includeindustry veteran Meggie Isom, formerly of AMC
                    Theatres and Cinema Scene, alongside Amanda Rufener, who
                    brings over a decade of experience from Lionsgate.
                    Completing the team is Laura Beth Boley, fresh from WTA
                    Media, and Nick Polydoros, an invaluable asset to
                    PaperAirplane for the past two years.
                  </p>
                </Header.Subheader>
              </Header>
            </div>
          </div>
        </div>
      </div> */}

      <div
        id="press"
        style={{
          width: "100%",
          // height: "calc(100vh - 50px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: "50px 30px",
          scrollMarginTop: "100px",
        }}
      >
        <div data-aos="fade-up">
          <div
            className="heading heading--inverted"
            style={{ fontSize: "3.2em", textAlign: "center", padding: "50px" }}
            data-aos="fade-up"
          >
            <ChromeTitle text="In The Press" />
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "50px",
          }}
          data-aos="fade-up"
        >
          <Press />
        </div>
      </div>

      <div
        id="team"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: "90px 30px",
          scrollMarginTop: "100px",
        }}
      >
        <div data-aos="fade-up">
          <div
            className="heading heading--inverted"
            style={{ fontSize: "3.2em", textAlign: "center" }}
            data-aos="fade-up"
          >
            <ChromeTitle text="Our Team" />
            <div
              className="heading__sub"
              style={{
                maxWidth: "800px",
                textAlign: "center",
                padding: "20px",
                fontSize: "1.2rem",
              }}
            >
              <p data-aos="fade-up">
                Co‑founders Mike Polydoros and Will Preuss bring deep expertise
                in cinema marketing, having led in‑theatre campaigns for
                hundreds of films, including franchises THE HUNGER GAMES, THE
                EXPENDABLES, SAW, TYLER PERRY and JOHN WICK, as well as
                acclaimed box‑office hits WONDER, LA LA LAND and KNIVES OUT.
                PaperAirplane builds on that track record by developing tools
                and strategies that reach moviegoers and drive box office
                success. Since launching in 2020, PaperAirplane has created and
                executed in‑theatre campaigns for films including FREELANCE,
                RADICAL, THE LONG GAME, HYPNOTIC and the Academy Award–winning
                GODZILLA MINUS ONE.
              </p>
              <p data-aos="fade-up">
                Key members of the PaperAirplane flight crew include industry
                veteran Meggie Isom (formerly of AMC Theatres and Cinema Scene),
                Amanda Rufener (over a decade at Lionsgate), Laura Beth Boley
                (recently from WTA Media), and Nick Polydoros, who joined the
                team in 2022. Alex Franklin brings decades of experience and
                runs the Radio Ambassador Program, while Tyler Coon supports the
                team as Exhibitor Marketing Coordinator, strengthening
                PaperAirplane’s exhibitor‑facing and promotional capabilities.
                Eric Marti rounds out the flight crew as the company’s Chief
                Technology Officer, overseeing the technical systems and product
                development that power PaperAirplane’s marketing tools.
              </p>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
          }}
          className="wrap-section"
          data-aos="fade-up"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
              maxWidth: "1000px",
            }}
          >
            <div
              data-aos="fade-up"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <img width="200px" src="./images/team/Mike.png" />
              <div className="heading heading--inverted">Mike Polydoros</div>
            </div>
            <div
              data-aos="fade-up"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <img width="200px" src="./images/team/Will.png" />
              <div className="heading heading--inverted">Will Preuss</div>
            </div>
            <div
              data-aos="fade-up"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <img width="200px" src="./images/team/Meggie.png" />
              <div className="heading heading--inverted">Meggie Isom</div>
            </div>
            <div
              data-aos="fade-up"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <img width="200px" src="./images/team/Amanda.png" />
              <div className="heading heading--inverted">Amanda Rufener</div>
            </div>
            <div
              data-aos="fade-up"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <img width="200px" src="./images/team/LB.png" />
              <div className="heading heading--inverted">Laura Beth Boley</div>
            </div>
            <div
              data-aos="fade-up"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <img width="200px" src="./images/team/Nick.png" />
              <div className="heading heading--inverted">Nick Polydoros</div>
            </div>
            <div
              data-aos="fade-up"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <img width="200px" src="./images/team/Tyler.png" />
              <div className="heading heading--inverted">Tyler Coon</div>
            </div>
            <div
              data-aos="fade-up"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <img width="200px" src="./images/team/Alex.png" />
              <div className="heading heading--inverted">Alex Franklin</div>
            </div>
            <div
              data-aos="fade-up"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                padding: "10px",
              }}
            >
              <img width="200px" src="./images/team/Eric.png" />
              <div className="heading heading--inverted">Eric Marti</div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="footer"
        style={{
          height: "30px",
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <span style={{ color: "#888888", fontSize: "12px" }}>
          &copy; {new Date().getFullYear()} PaperAirMedia. All Rights Reserved.
        </span>
      </div>
      {modalOpen && <Contact setModal={setModal} />}
    </div>
  );
};

export default Home;
